import { HomeTab } from 'areas/summary/types';
import { ApiRequest } from 'framework/api';
import { UrlBuilder } from 'tools';

export function clearUserSettings() {
	return new ApiRequest({
		url: 'userSettings/deleteAll',
		method: 'POST',
	});
}
export class UserDataLite {
	id: string;
	username: string;
	firstName: string;
	lastName: string;
}

export function convertType(userId: string) {
	return new ApiRequest({
		method: 'POST',
		url: `users/${userId}/authType/CEEVIEW`,
		accountBased: true,
	});
}

export function getUser(userId: string) {
	return new ApiRequest<UserDataLite>({
		url: `users/${userId}/lite`,
		accountBased: true,
	});
}

export function getUserHomeTabs({ userId, loginAccountId }: { userId: string; loginAccountId: string }) {
	const url = new UrlBuilder(`users/${userId}/landingPages`)
		.add('loginAccountId', loginAccountId, !!loginAccountId)
		.build();

	return new ApiRequest<HomeTab[]>({
		url,
		accountBased: true,
	});
}

export function saveUserHomeTabs({
	userId,
	loginAccountId,
	tabsIds,
}: {
	userId: string;
	loginAccountId: string;
	tabsIds: string[];
}) {
	const url = new UrlBuilder(`users/${userId}/landingPages`)
		.add('loginAccountId', loginAccountId, !!loginAccountId)
		.build();

	return new ApiRequest({
		url,
		accountBased: true,
		method: 'POST',
		payload: tabsIds,
	});
}

export interface RoleInfo {
	id: string;
	name: string;
	description: string;
	type: string;
	roles: string[];
}

export function listRoles({ accountId }: { accountId: string }) {
	return new ApiRequest<RoleInfo[]>({
		url: 'usercategories/lite/',
		accountBased: true,
		accountId,
	});
}
